import { Avatar, Box, Typography, useTheme } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { avtarImg } from "@platformx/shared/static-assets";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import CommonPlateformXDialog from "../../components/Modal/CommonPlateformXDialog";
import usePlatformAnalytics from "../../hooks/usePlatformAnalytics/usePlatformAnalytics";
import useUserSession from "../../hooks/useUserSession/useUserSession";
import { handleLogout } from "../../utils/helper";
import { capitalizeFirstLetter } from "../../utils/helperFns";
import { XToolTip } from "../XToolTip/XToolTip";
import { Users } from "./Header.types";
import { useStyle } from "./MiniHeader.styles";

const saveWarningMessage = {
  saveWarnTitle: "Unsaved Changes",
  saveWarnSubtitle:
    "You have unsaved changes, do you want to save them before moving out of this window?",
  saveWarnSave: "Save",
  saveWarnReject: "Take me out",
};

export const MiniHeader = ({ showUserDetails = true }: Users) => {
  const classes = useStyle();
  const { t } = useTranslation();
  const theme = useTheme();
  const [getSession, updateSession] = useUserSession();
  const userSession = getSession();
  // const { state, dispatch } = useContext(Store); // TODO
  // const { page } = state;
  // const { quiz } = state;
  const navigate = useNavigate();
  const location = useLocation();
  const { saveWarnTitle, saveWarnSubtitle, saveWarnSave, saveWarnReject } = saveWarningMessage;
  const [anchorE2, setAnchorE2] = React.useState<null | HTMLElement>(null);
  const [hasSaveWarning, setHasSaveWarning] = React.useState<boolean>(false);
  const openMenu = Boolean(anchorE2);
  const [triggerCase, setTriggerCase] = useState("");
  const [backgroundStyle, setBackgroundstyle] = useState("");

  useEffect(() => {
    setBackgroundstyle(theme?.palette.customColor?.BGLIGHT);
    return () => {
      setBackgroundstyle("");
    };
  }, []);

  const onCloseSaveWarningHandler = () => {
    setHasSaveWarning(false);
    // dispatch(callSaveandResetWarning(true));
  };
  const handleOpen = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorE2(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorE2(null);
  };
  const hasUnsavedChanges = () => {
    // if (location.pathname.includes('/edit-page') && page?.showSaveWarning) {
    if (location.pathname.includes("/edit-page")) {
      setHasSaveWarning(true);
      return true;
    } else if (
      location.pathname.includes("/create-quiz")
      // &&      quiz?.isUnsavedQuiz
    ) {
      setHasSaveWarning(true);
      return true;
    } else if (location.pathname.includes("/create-vod")) {
      setHasSaveWarning(true);
      return true;
    } else if (location.pathname.includes("/create-poll")) {
      setHasSaveWarning(true);
      return true;
    } else if (location.pathname.includes("/create-event")) {
      setHasSaveWarning(true);
      return true;
    } else {
      return false;
    }
  };
  const [handleImpression] = usePlatformAnalytics();
  const callFnsCase = (triggerCaseSent: any) => {
    setHasSaveWarning(false);
    switch (triggerCaseSent) {
      case "CHANGE_PWD":
        setAnchorE2(null);
        navigate("/change-password");
        break;
      case "LOGOUT":
        handleLogout();
        break;
      case "PAGE_LIST":
        navigate("/sitepage");
        break;
      default: {
        // const pageDataObj = {
        //   eventType: "Logout User by Default Case",
        //   LogOutUser: true,
        // };
        // handleImpression(pageDataObj.eventType, pageDataObj);
        // localStorage.removeItem("selectedSite");
        // localStorage.removeItem("imageUuid");
        // localStorage.removeItem("videoUuid");
        // localStorage.removeItem("path");

        // updateSession(null); // TODO:  Check if this is required
        // window.location.href = NEW_LOGOUT_URL;
        // handleLogout();
        // eslint-disable-next-line no-console
        console.log("MiniHeader - Default case of callFnsCase triggered");
        break;
      }
    }
  };
  const handleChangePassword = () => {
    setTriggerCase("CHANGE_PWD");
    if (!hasUnsavedChanges()) {
      callFnsCase("CHANGE_PWD");
    }
  };

  const handleLogoutFns = () => {
    handleLogout();
  };

  const { role } = userSession;
  return (location.pathname === "/change-password" ||
    location.pathname.includes("/preview-page") ||
    location.pathname.includes("/article-preview") ||
    location.pathname.includes("/vod-preview")) &&
    userSession?.isActive ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <></>
  ) : (
    <Box
      sx={{
        width: "100%",
      }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
        }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Avatar sx={{ width: 30, height: 30 }} src={`${avtarImg}`} onClick={handleOpen} />
          {showUserDetails && (
            <Box className={classes.userContainer}>
              <XToolTip
                position='top-start'
                Title={capitalizeFirstLetter(userSession?.userInfo?.name)}
                className={classes.ellipses}
                component={
                  <Typography variant='h6medium' ml={2} className={classes.ellipses}>
                    {capitalizeFirstLetter(userSession?.userInfo?.name)}
                  </Typography>
                }
              />
              <Typography
                component='div'
                variant='p4regular'
                sx={{ textTransform: "capitalize" }}
                ml={2}>
                {t(role)}
              </Typography>
            </Box>
          )}
        </Box>
        <Menu
          anchorEl={anchorE2}
          open={openMenu}
          onClose={handleCloseMenu}
          sx={{
            ".Platform-x-Menu-paper": {
              boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
              borderRadius: "7px",
              marginLeft: "45px",
            },
          }}>
          <MenuItem
            style={{ background: backgroundStyle }}
            disableRipple
            onClick={handleChangePassword}
            onMouseEnter={() => {
              setBackgroundstyle(theme?.palette.customColor?.BGWEAK);
            }}
            onMouseLeave={() => {
              setBackgroundstyle(theme?.palette.customColor?.BGLIGHT);
            }}
            sx={{
              backgroundColor: theme?.palette.customColor?.BGLIGHT,
              "&:hover": {
                backgroundColor: theme?.palette.customColor?.BGWEAK,
              },
            }}>
            {t("change_password")}
          </MenuItem>
          <MenuItem
            disableRipple
            onClick={handleLogoutFns}
            sx={{
              backgroundColor: theme?.palette.customColor?.BGLIGHT,
              "&:hover": {
                backgroundColor: theme?.palette.customColor?.INPUT,
              },
            }}>
            {t("logout")}
          </MenuItem>
        </Menu>
      </Box>
      {hasSaveWarning ? (
        <CommonPlateformXDialog
          isDialogOpen={hasSaveWarning}
          title={saveWarnTitle}
          subTitle={saveWarnSubtitle}
          closeButtonText={saveWarnReject}
          confirmButtonText={saveWarnSave}
          confirmButtonHandle={() => callFnsCase(triggerCase)}
          closeButtonHandle={onCloseSaveWarningHandler}
          modalType='unsavedChanges'
        />
      ) : null}
    </Box>
  );
};
